"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("damages").config(config);

  function config($stateProvider) {
    $stateProvider.state("damages", {
      url: "/damages",
      templateUrl: "app/pages/damages/damages.html",
      controller: "DamagesCtrl",
      controllerAs: "vm",
      resolve: {
        ready: function ready($q, $rootScope) {
          var deferred = $q.defer();
          if ($rootScope.$user) {
            deferred.resolve("");
          } else {
            $rootScope.$watch(function () {
              return $rootScope.$user;
            }, function () {
              if ($rootScope.$user) {
                deferred.resolve("");
              }
            }, true);
          }
          return deferred.promise;
        }
      }
    });
  }
})();